import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { grey } from '@material-ui/core/colors';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import CustomDialog from '@configuratorware/configurator-frontendgui/Shared/Components/CustomDialog';
import MainButton from '@configuratorware/configurator-frontendgui/Shared/Components/MainButton';

const useStyles = makeStyles(
  (theme) => ({
    dialogTitleRoot: {
      padding: '12px 12px 20px',
      fontSize: '1.5rem',
      fontWeight: 400,
    },
    dialogContentRoot: {
      padding: '0 24px 24px 12px',
    },
    pdfDownloadDialog: {
      borderTop: '7px solid ' + theme.palette.primary.main,
    },
    activeButton: {
      textTransform: 'none',
      whiteSpace: 'nowrap',
      padding: '4px 15px',
      backgroundColor: grey[900],
      color: 'white',
      textDecoration: 'none',
      '&:hover': {
        backgroundColor: grey[700],
      },
    },
    activeButtonLabel: {
      color: 'white',
    },
    TypographyCaption: {
      fontSize: 12,
      lineHeight: 1.7,
    },
  }),
  { name: 'CustomPdfDownload' }
);

const CustomPdfDownload = ({ show, onClose }) => {
  const classes = useStyles();
  const [pdfUrl, setPdfUrl] = useState('');

  useEffect(() => {
    show && creatPdfUrl();
  }, [show]);

  const creatPdfUrl = async () => {
    const pdfUrl = await Services.interaction.createPdfUrl('user');
    setPdfUrl(pdfUrl);
  };

  return (
    <CustomDialog
      open={show}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      dialogTitle={t('pdfDownloadDialog.title')}
      onCancel={onClose}
    >
      <DialogContent className={classes.dialogContentRoot}>
        <Typography
          variant="body1"
          classes={{ root: classes.TypographyCaption }}
          id="alert-dialog-description"
        >
          {t('pdfDownloadDialog.content')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <MainButton
          href={pdfUrl}
          target="_blank"
          variant="contained"
          classes={{
            root: classes.activeButton,
            label: classes.activeButtonLabel,
          }}
        >
          {t('pdfDownloadDialog.actionButton')}
        </MainButton>
      </DialogActions>
    </CustomDialog>
  );
};

CustomPdfDownload.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  code: PropTypes.string,
};

export default CustomPdfDownload;
